
define(
	'Convergence.ShopByCatBrand.ShopByCatBrand'
,   [
		'Convergence.ShopByCatBrand.ShopByCatBrand.View'
	,	'Convergence.ShopByCatBrand.ShopByCatBrand.Collection'
	,	'Configuration'
	]
,   function (
		ShopByCatBrandView
	,	ShopByCatBrandCollection
	,	Configuration
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var brandCollection = new ShopByCatBrandCollection();
			var configurationData = Configuration.get('ShopByCatBrand.startWith');
			// console.log(configurationData);
			var createInitObj=[{
					
					categoryID: "2",
					CategoriesinitID:'101',
					startWith:'Category'
				},{
					
					categoryID: '1',
					CategoriesinitID:'5',
					startWith:'Brands'
				}];
				var configurationSetup;
			if(configurationData === 'Categories'){
				// Do something with the configuration data
				configurationSetup = {
					
					categoryID: "2",
					startWith: configurationData,
					CategoriesinitID:'101'
				}
			}
			if(configurationData === 'Brands'){
				// Do something with the configuration data
				configurationSetup = {
					
					categoryID: '1',
					startWith: configurationData,
					CategoriesinitID:'5'
				}
			}
			
			
			
				if (layout) {
					layout.addChildView('ShopBy.Categories.Brand', function() { 
						// console.log('Convergence.ShopByCatBrand.ShopByCatBrand.mountToApp', res);
						
						
						return new ShopByCatBrandView({ 
							container: container,
							collection: brandCollection, // pass the fetched collection to the view,
							currentSelectedObj: configurationSetup,
							createInitObj: createInitObj
							
						});
					});
				}

		}
	};
});
